import { render, staticRenderFns } from "./InplayList.vue?vue&type=template&id=148e3172&scoped=true"
import script from "./InplayList.vue?vue&type=script&lang=js"
export * from "./InplayList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148e3172",
  null
  
)

export default component.exports